import { render, staticRenderFns } from "./spreadsheet_extension.vue?vue&type=template&id=9f198658"
import script from "./spreadsheet_extension.vue?vue&type=script&lang=js"
export * from "./spreadsheet_extension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports